import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { JpClassStaff } from "./JpClassStaff";
import type { JpClassStaggerDTOBase } from "./JpClassStaggerDTOBase";
import type { TrackedBase } from "./TrackedBase";

export class JpClassStaggerStaff implements JpClassStaggerDTOBase, TrackedBase {
  constructor(public readonly staggerId: number, public readonly instanceId: JpClassStaff | null, public readonly staggerDate: Date, public readonly occupancy: number, public readonly reserveOnly: string | null, public readonly reserveRelease: Date | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.instanceIdLoaded = this.instanceId != null;
    this.instanceIdCached = this.instanceId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private instanceIdLoaded: boolean;
  private instanceIdCached: JpClassStaff | null;
  async instanceIdLazy(): Promise<JpClassStaff> {
    if (!this.instanceIdLoaded) {
      this.instanceIdCached = await this.cbiServiceContext!.jpClassService().getJpClassStaggerStaffInstanceId(this.staggerId);
      this.instanceIdLoaded = true;
    }
    return this.instanceIdCached!;
  }
}
